import { render, staticRenderFns } from "./SurveyFillerAgeConfirmation.vue?vue&type=template&id=4e1cab1c&scoped=true"
import script from "./SurveyFillerAgeConfirmation.vue?vue&type=script&lang=js"
export * from "./SurveyFillerAgeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SurveyFillerAgeConfirmation.vue?vue&type=style&index=0&id=4e1cab1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1cab1c",
  null
  
)

export default component.exports